var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15.529785px",
    viewBox: "0 0 20 15.529785",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chack-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65838 15.2306C7.46746 15.4226 7.20699 15.5297 6.93642 15.5297C6.66586 15.5297 6.40539 15.4226 6.21447 15.2306L0.448766 9.46391C-0.149589 8.86556 -0.149589 7.89529 0.448766 7.29806L1.17072 6.57592C1.76926 5.97756 2.73841 5.97756 3.33676 6.57592L6.93642 10.1758L16.6632 0.448766C17.2618 -0.149589 18.2319 -0.149589 18.8293 0.448766L19.5512 1.1709C20.1496 1.76926 20.1496 2.73934 19.5512 3.33676L7.65838 15.2306Z",
    id: "Forma",
    fill: "#10B48C",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.641f9bba70b39e456abf27ea356a7e5f.svg";
export { ForwardRef as ReactComponent };